import { __decorate } from "tslib";
import { ApiResource } from '../../lib/api-decorators';
import { Api } from '../../lib/api.factory';
let AuthResource = class AuthResource extends Api {
    async login(email, password) {
        return this.post('/login', { email, password });
    }
    async logout() {
        return this.post('/logout');
    }
};
AuthResource = __decorate([
    ApiResource('/auth')
], AuthResource);
export { AuthResource };
